import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AryaChatComponent } from './arya-chat.component';
import { AryaPageComponent } from './arya-page.component';
import { AryaSetupComponent } from './arya-setup.component';

@NgModule({
  declarations: [AryaChatComponent, AryaPageComponent, AryaSetupComponent],
  imports: [CommonModule, FormsModule, RouterModule],
  exports: [AryaChatComponent, AryaPageComponent, AryaSetupComponent],
})
export class AryaChatModule {}
